import { createSlice } from "@reduxjs/toolkit";

const successMessageSlice = createSlice({
  name: "successMessageSlice",
  initialState: {
    showMessage: false,
    defaultMessage: "",
    message: "",
    showInfo: false,
    errorInfo: false,
    title: "",
    defaultTitle: "",
    showEmailVerification: false,
    callFunOnGotIt: null
  },
  reducers: {
    setShowMessage: (state, action) => {
      state.showMessage = action.payload.showMessage;
      state.defaultMessage = action.payload.defaultMessage;
      state.message = action.payload.message;
    },
    setShowInfo: (state, action) => {
      state.showInfo = action.payload.showInfo;
      state.defaultMessage = action.payload.defaultMessage;
      state.message = action.payload.message;
      state.title = action.payload.title;
      state.defaultTitle = action.payload.defaultTitle;
    },
    setErrorInfo: (state, action) => {
      state.errorInfo = action.payload.errorInfo;
      state.defaultMessage = action.payload.defaultMessage;
      state.message = action.payload.message;
      state.title = action.payload.title;
      state.defaultTitle = action.payload.defaultTitle;
    },
    setShowEmailVerification: (state, action) => {
      state.showEmailVerification = action.payload;
    },
    setCallFunOnGotIt: (state, action) => {
      state.callFunOnGotIt = action?.payload
    }
  },
});

// this is for dispatch
export const {
  setShowMessage,
  setShowInfo,
  setErrorInfo,
  setShowEmailVerification,
  setCallFunOnGotIt
} = successMessageSlice.actions;

// this is for configureStore
export default successMessageSlice.reducer;
